var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpecificProducts = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 80 80"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: 2,
  d: "M74 58.556a.556.556 0 0 0-.556-.556H7.294a.294.294 0 0 0-.294.294A4.706 4.706 0 0 0 11.706 63h57.85A4.444 4.444 0 0 0 74 58.556ZM10 52a2 2 0 0 0 2 2h57a1 1 0 0 0 1-1V19a3 3 0 0 0-3-3H13a3 3 0 0 0-3 3z"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 2,
  d: "M14 48a2 2 0 0 0 2 2h48a2 2 0 0 0 2-2V22a2 2 0 0 0-2-2H16a2 2 0 0 0-2 2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 51V37M45 51V34M21 51V27M48 51V37M24 51V27M51 51V37M27 51v-9M54 51V31M30 51v-9M57 51V25M33 51V34M60 51V27M63 51V37M36 51V34M39 51V32M42 51V32"
}))));
export default SvgSpecificProducts;